import React from 'react';
import IToastSuccessMessage from './interfaces/IToastSuccessMessage';

import { ReactComponent as SuccessIcon } from '../assets/icons/toastify-success.svg';

const ToastSuccessMessage = ({ message, children }:IToastSuccessMessage) => (
  <>
    <SuccessIcon />
    <span className="mx-2">
      {message}
    </span>
    {children}
  </>
);

export default ToastSuccessMessage;
